module.exports = __webpack_public_path__ + "img/badge-expertise-gold-brightbg.03bcc6a5.svg";